import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import { showToast } from "../../App";
import { ToastType } from "../../Contexts/Notification";
import { Buttons } from "../Atoms/Button/Button";
import AppContext from "Contexts/AppContext";

interface VerifyOtpComponentProps {
  email: string;
  onSuccess: (token: string) => void;
  onBack?: () => void;
}

const VerifyOtpComponent: React.FC<VerifyOtpComponentProps> = ({ email, onSuccess, onBack }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState("");
  const [hasSubmittedOtp, setHasSubmittedOtp] = useState(false);

  
  const {setLoader } = useContext(AppContext);

  const verifyAuthOtp = httpsCallable(functions, "verifyAuthOtp");

  // Auto-submit when OTP is complete
  useEffect(() => {
    const otpString = otp.join("");
    if (otpString.length === 6 && !isVerifying && !hasSubmittedOtp) {
      const timer = setTimeout(() => {
        handleSubmit(new Event("submit") as any);
        setHasSubmittedOtp(true); // Prevent re-submission
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [otp, isVerifying, hasSubmittedOtp]);
  

  const handleChange = (index: number, value: string) => {
    if (!/^[0-9]?$/.test(value)) return;
  
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setHasSubmittedOtp(false); // Allow retry after user changes input
  
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) (nextInput as HTMLInputElement).focus();
    }
  };
  

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (paste.length === 6) {
      setOtp(paste.split(""));
      setHasSubmittedOtp(false); // Allow new submission after paste
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      setError("OTP must be 6 digits");
      return;
    }
    setIsVerifying(true);
    try {
      const response: any = await verifyAuthOtp({ email, otp: otpValue });
      const token = response?.data?.data?.token;
      if (token) {
        onSuccess(token);
        if(setLoader)setLoader(true);
      } else {
        setError("Invalid OTP");
      }
    } catch (error: any) {
      showToast(error.message || "OTP verification failed", ToastType.ERROR);
      setError(error.message || "OTP verification failed");
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="w-100 mt-4">
      <div className="d-flex justify-content-center">
        <h6 className="text-center mb-4" style={{color:"white"}}> Please enter the code sent to your email</h6>
      </div>
      <div className="mb-3 w-100 d-flex justify-content-between" style={{ gap: 8 }}>
        {otp.map((digit, idx) => (
          <input
            key={idx}
            id={`otp-input-${idx}`}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            value={digit}
            autoFocus={idx === 0}
            onChange={e => handleChange(idx, e.target.value)}
            onPaste={handlePaste}
            style={{ width: 40, height: 48, textAlign: "center", fontSize: 24, borderRadius: 6, border: "1px solid #ccc" }}
            disabled={isVerifying}
          />
        ))}
      </div>
      {error && <div className="text-danger mb-2">{error}</div>}    
      {onBack && (
        <Buttons.ClickableText type="button" onClick={onBack} fullWidth style={{ marginTop: 8 ,color:"white" , textDecoration:"underline"}}>
          Back
        </Buttons.ClickableText>
      )}
    </Form>
  );
};

export default VerifyOtpComponent; 